// Formats a flag name of the form `group/feature_name` (Feature service form) into the
// form `group-feature-name` (LaunchDarkly form).
export function formatFeatureServiceFlagNameToLaunchDarkly(flagName) {
  return flagName.replace('/', '-').replace(/_/g, '-');
}

// Formats a flag name of the form `group-feature-name` (LaunchDarkly form) into the
// form `group/feature_name` (Feature service form).
export function formatLaunchDarklyFlagNameToFeatureService(flagName) {
  return flagName.replace('-', '/').replace(/-/g, '_');
}

// If the flag name contains a `/`, it is a feature service flag name and it will be converted to LD name, since
// LD key can not contain '/' characters.
// Otherwise, flag name is assumed to be a LD key and will be returned as is.
// See naming standards for LD keys: https://docs.google.com/document/d/1VqSBupTJLT1b_k2LuSq_gKp1GtgukoN6qIFuDE7tVzU/edit
export function formatToLaunchdarklyKeyIfNeeded(flagName) {
  let ldFlagKey;
  if (flagName.includes('/')) {
    ldFlagKey = formatFeatureServiceFlagNameToLaunchDarkly(flagName);
  } else {
    ldFlagKey = flagName;
  }
  return ldFlagKey;
}